import React, {useState, useEffect} from 'react';
import MapPicker from 'react-google-map-picker';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import Button from '@mui/material/Button';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import Api from '@api';
import Autocomplete from 'react-google-autocomplete';
import {GoogleMapsAPI} from './g-config';
import Debounce from './debounce';
import regex from '@regex';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  bgcolor: '#00000000',
  // border: '2px solid #000',
  // boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  display: 'none',
};

const DefaultLocation = {
  lat: 12.9134051743803,
  lng: 77.6706832097168,
};
const DefaultZoom = 10;
let myobj = {
  locName: '',
  latitude: '',
  longitude: '',
  city: '',
  state: '',
  pincode: '',
  district: '',
  subDistrict: '',
  area: '',
  locality: '',
};

export default function index(props) {
  const [defaultLocation, setDefaultLocation] = useState(DefaultLocation);
  const [location, setLocation] = useState(defaultLocation);
  const [zoom, setZoom] = useState(DefaultZoom);
  useEffect(() => {
    handleChangeLocation(
      props?.defaultValue?.latitude || DefaultLocation.lat,
      props?.defaultValue?.longitude || DefaultLocation.lng,
    );
  }, []);

  useEffect(() => {
    let obj = {
      lat: Number(props?.defaultValue?.latitude || DefaultLocation.lat),
      lng: Number(props?.defaultValue?.longitude || DefaultLocation.lng),
    };
    setDefaultLocation({...obj});
    setLocation({...obj});
  }, [props?.defaultValue]);

  function handleChangeLocation(lat, lng) {
    setLocation({lat: lat, lng: lng});
  }
  const getAddressComponent = (addressArray, type) => {
    if (!Array.isArray(addressArray)) return '';
  
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types.includes(type)) {
        return addressArray[i].long_name;
      }
    }
  
    return '';
  };
  
  const getCity = (addressArray) => getAddressComponent(addressArray, 'locality') || getAddressComponent(addressArray, 'administrative_area_level_3');
  
  const getArea = (addressArray) => getAddressComponent(addressArray, 'sublocality_level_1') || getAddressComponent(addressArray, 'locality');
  
  const getState = (addressArray) => getAddressComponent(addressArray, 'administrative_area_level_1');
  
  const getDistrict = (addressArray) => getAddressComponent(addressArray, 'administrative_area_level_3');
  
  const getSubDistrict = (addressArray) => getAddressComponent(addressArray, 'sublocality_level_1') || getAddressComponent(addressArray, 'locality');
  
  const getPincode = (addressArray) => getAddressComponent(addressArray, 'postal_code');
  
  const getLocality = (addressArray) => getAddressComponent(addressArray, 'locality') || getAddressComponent(addressArray, 'establishment');

  function handleChangeZoom(newZoom) {
    setZoom(newZoom);
  }

  function handleResetLocation() {
    setDefaultLocation({...DefaultLocation});
    setZoom(DefaultZoom);
  }

  const styleMap = {
    minWidth: '98%',
    minHeight: '400px',
    display: 'inline-block',
  };
  // var mapObject, picker;
  const [open, setOpen] = useState(false);
  const [mapData, setMapData] = useState(null);
  const [geocodeWarning, setGeocodeWarning] = useState(null);

  useEffect(() => {
    if (props?.defaultValue?.longitude) {
      setMapData({
        locName: props?.defaultValue?.locName,
        latitude: props?.defaultValue?.latitude,
        longitude: props?.defaultValue?.longitude,
        city: props?.defaultValue?.city,
        state: props?.defaultValue?.state,
        pincode: props?.defaultValue?.pincode,
        district: props?.defaultValue?.district,
        subDistrict: props?.defaultValue?.subDistrict,
        area: props?.defaultValue?.area,
      });
      setLocation({
        lat: props?.defaultValue?.latitude,
        lng: props?.defaultValue?.longitude,
      });
    }
  }, []);

  useEffect(() => {
    if (mapData) {
      props?.onChange(mapData);
    }
  }, [mapData]);

  const handleClose = () => {
    setOpen(false);
  };

  const confirmLocation = () => {
    if (!location?.lat || !location?.lng) return;

    // If a no-address warning is already shown, the user has acknowledged it.
    // Confirm directly with lat/lng only, skipping a redundant geocoder call.
    if (geocodeWarning) {
      setMapData({
        locName: '',
        latitude: location.lat,
        longitude: location.lng,
        city: '',
        state: '',
        pincode: '',
        district: '',
        subDistrict: '',
        area: '',
        locality: '',
      });
      setGeocodeWarning(null);
      setOpen(false);
      return;
    }

    const geocoder = new google.maps.Geocoder();
    const latlng = { lat: parseFloat(location.lat), lng: parseFloat(location.lng) };

    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === "OK" && results?.length) {
        // Use your regex filter to allow only English addresses
        const filteredAddress = results.filter(item =>
          !regex.onlyEnglishRegex.test(item.formatted_address)
        );

        const selected = filteredAddress?.[0] || results?.[0]; // fallback to first result if none match

        const address = selected.formatted_address;
        const addressArray = selected.address_components;

        const city = getCity(addressArray);
        const area = getArea(addressArray);
        const state = getState(addressArray);
        const district = getDistrict(addressArray);
        const subDistrict = getSubDistrict(addressArray);
        const pincode = getPincode(addressArray);
        const locality = getLocality(addressArray);

        const newMyobj = {
          locName: address,
          latitude: location.lat,
          longitude: location.lng,
          city,
          state,
          pincode,
          district,
          subDistrict,
          area,
          locality,
        };

        setMapData(newMyobj);
        setOpen(false);
      } else if (status === 'ZERO_RESULTS') {
        // Show warning in dialog; keep dialog open so user can read it.
        // Next confirm click will use the geocodeWarning shortcut above.
        setGeocodeWarning('No address found — latitude and longitude will be saved, but address fields will be empty. Click Confirm again to proceed.');
      } else {
        console.error("Geocoder failed due to:", status);
      }
    });
  };
  

  return (
    <>
      <TextField
        id={props.id}
        label={props.label}
        value={mapData?.locName || ''}
        InputProps={{
          endAdornment: (
            <InputAdornment position='start'>
              {props.disabled === 'disabled' ? (
                <AddLocationIcon onClick={() => setOpen(false)} />
              ) : (
                <AddLocationIcon onClick={() => { setGeocodeWarning(null); setOpen(true); }} />
              )}
            </InputAdornment>
          ),
        }}
        variant='outlined'
        fullWidth
        size={props.size}
        error={props.error}
        helperText={props.helperText}
        required={true}
        disabled={true}
      />
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgb(0 0 0 / 60%)',
          display: open ? 'block' : 'none',
          zIndex: 1300,
        }}
        onClick={() => setOpen(false)}
      ></div>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        maxWidth='false'
        PaperProps={{
          sx: {
            width: '80%',
            maxHeight: 500,
          },
        }}
      >
        {/* <DialogTitle id="alert-dialog-title">
                    {"Confirm to Deactivate"}
                    </DialogTitle> */}
        <DialogContent style={{padding: '5px 5px'}}>
          {/* <Autocomplete
            apiKey={GoogleMapsAPI}
            style={{width: '100%', height: '30px'}}
            onPlaceSelected={(place) => {
              handleChangeLocation(
                place.geometry.location.lat(),
                place.geometry.location.lng(),
              );
              setLocation({
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
              });
              setZoom(12);
            }}
            options={{
              types: ['establishment'],
              componentRestrictions: {country: 'in'},
            }}
            placeholder='Search Location'
            // defaultValue="New Delhi"
          /> */}
          <Debounce onLocationChange={handleChangeLocation} />
          <MapPicker
            defaultLocation={location}
            zoom={zoom}
            mapTypeId='roadmap'
            style={{maxHeight: '424px'}}
            onChangeLocation={handleChangeLocation}
            onChangeZoom={handleChangeZoom}
            apiKey={GoogleMapsAPI}
          />
          {geocodeWarning && (
            <DialogContentText sx={{color: '#ed6c02', textAlign: 'center', py: 0.5, fontSize: '13px'}}>
              {geocodeWarning}
            </DialogContentText>
          )}
          <DialogContentText
            id='alert-dialog-description'
            style={{textAlign: 'center', paddingTop: '2px'}}
          >
            <Button variant='contained' onClick={confirmLocation}>
              Confirm Location
            </Button>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}